import { makeStyles } from '@material-ui/core/styles'
import { headerHeight, toolbarHeight, topbarHeight } from './Constants'

export const appStyle = makeStyles((theme) => ({
  '@global': {
    body: {
      overflow: 'hidden'
    },
    '*::-webkit-scrollbar': {
      width: '0.6em'
    },
    '*::-webkit-scrollbar-track': {
      borderWidth: 1,
      borderStyle: 'solid',
      borderColor: '#ccc'
    },
    '*::-webkit-scrollbar-thumb': {
      width: '0.3em',
      backgroundColor: '#cccccc',
      backgroundClip: 'padding-box',
      borderWidth: 1,
      borderStyle: 'solid',
      borderColor: '#999'
    }
  },
  errorMessage: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-around',
    paddingTop: theme.spacing(2),
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    fontSize: '0.8rem',
    textAlign: 'center'
  },
  errorIcon: {
    marginBottom: theme.spacing(1)
  },
  mainContainer: {
    flex: 1,
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    overflow: 'hidden',
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    }
  },
  mobileContainer: {
    display: 'none',
    [theme.breakpoints.down('sm')]: {
      display: 'block'
    }
  },
  mobileWarning: {
    padding: theme.spacing(2)
  },
  mainArea: {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
    background: theme.palette.common.white
  },
  mainContentArea: {
    flex: 1
  },
  toolbar: {
    flex: `0 0 ${toolbarHeight}px`,
    height: toolbarHeight
  },
  bottomBar: {
    position: 'absolute',
    bottom: 0,
    left: 50,
    right: 0,
    zIndex: 700
  },
  leftSideBar: {
    position: 'absolute',
    left: 0,
    top: headerHeight,
    zIndex: 1000
  },
  progressIcon: {
    color: theme.palette.primary.main,
    marginBottom: theme.spacing(1)
  },
  rightSideBar: {
    position: 'absolute',
    right: 0,
    top: headerHeight,
    zIndex: 999
  },
  topBar: {
    flex: `0 0 ${topbarHeight}px`,
    height: topbarHeight
  },
  wikiSideBar: {
    position: 'absolute',
    right: 0,
    top: headerHeight,
    zIndex: 1000
  }
}))
